module.exports = __webpack_public_path__ + "img/currency-exchange.3d4cb67c.svg";